if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slides = Array.from(this.querySelectorAll('.sl-product-modal__slide'));
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.querySelectorAll('[data-sl-modal-previous], [data-sl-modal-next]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
        });
        this.querySelector('[data-sl-modal-previous]')?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.showSlide(this.currentIndex - 1);
        });
        this.querySelector('[data-sl-modal-next]')?.addEventListener('click', (event) => {
          event.stopPropagation();
          this.showSlide(this.currentIndex + 1);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.showSlide(this.currentIndex - 1);
          if (event.key === 'ArrowRight') this.showSlide(this.currentIndex + 1);
        });
        this.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0].screenX;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].screenX - this.touchStartX;
          if (Math.abs(distance) < 45) return;
          this.showSlide(distance > 0 ? this.currentIndex - 1 : this.currentIndex + 1);
        }, { passive: true });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const nextIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
        this.showSlide(nextIndex < 0 ? 0 : nextIndex, false);
      }

      showSlide(index, smooth = true) {
        if (!this.slides.length) return;
        this.currentIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => slide.classList.toggle('active', slideIndex === this.currentIndex));
        this.slides[this.currentIndex].scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'nearest', inline: 'start' });
        const counter = this.querySelector('[data-sl-modal-current]');
        if (counter) counter.textContent = this.currentIndex + 1;
      }
    }
  );
}
